module.exports = __webpack_public_path__ + "static/img/avatar.b85e863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 44